import { Box, BoxProps, Modal, ModalOverlay } from "@chakra-ui/react";
import React, { ReactNode } from "react";

interface Props {
  children: ReactNode;
}

export const ScrollContext = React.createContext<React.RefObject<HTMLDivElement> | null>(null);

export const RevisionOverlay: React.FC<Props & BoxProps> = ({ children, ...props }) => {
  const scrollRef = React.useRef<HTMLDivElement | null>(null);

  return (
    <Modal isOpen={true} onClose={() => {}} size="full">
      <ModalOverlay>
        <ScrollContext.Provider value={scrollRef}>
          <Box
            ref={scrollRef}
            position="fixed"
            top="0"
            left="0"
            width="100%"
            height="100%"
            overflow="auto"
            zIndex={100}
            {...props}
          >
            {children}
          </Box>
        </ScrollContext.Provider>
      </ModalOverlay>
    </Modal>
  );
};
